import React from "react";
import { Link } from "react-router-dom";
import { policyDocuments, policyGroups } from "../Datas/policyData";
import "../css/privacy.scss";

function PolicyHub() {
  return (
    <main role="main" id="MainContent" className="main-content">
      <div className="shopify-policy__container policy-hub">
        <header className="shopify-policy__title">
          <p className="policy-kicker">Customer information</p>
          <h1>Policies &amp; Help</h1>
          <p className="policy-summary">
            Find clear information about shopping with Hound &amp; Home, using
            our website and getting help with an order.
          </p>
        </header>

        <div className="policy-groups">
          {policyGroups.map((group) => (
            <section className="policy-group" key={group.title}>
              <h2>{group.title}</h2>
              <p>{group.description}</p>
              <div className="policy-card-grid">
                {group.slugs.map((slug) => (
                  <Link className="policy-card" to={`/${slug}`} key={slug}>
                    <span>{policyDocuments[slug].title}</span>
                    <span aria-hidden="true">→</span>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="policy-contact">
          <h2>Need help finding the right policy?</h2>
          <p>
            Email{" "}
            <a href="mailto:packs@houndandhome.xyz">
              packs@houndandhome.xyz
            </a>
            , and include your order number if your question is about a
            purchase.
          </p>
        </div>
      </div>
    </main>
  );
}

export default PolicyHub;
